module.exports = __webpack_public_path__ + "img/saintsaturin.91bc9a90.jpg";